import type { RouteRecordRaw } from 'vue-router'
import PageHome from '@/views/app/home/page-home.vue'
import AuthRoutes from './modules/auth'
import BannerRoutes from './modules/banner'
import CourierRoutes from './modules/courier'
import CustomerRoutes from './modules/customer'
import ErrorRoutes from './modules/error'
import LoginBannerRoutes from './modules/login-banner'
import PasswordRoutes from './modules/password'
import PaymentMethodRoutes from './modules/payment-method'
import ProductRoutes from './modules/product'
import ProductCategoryRoutes from './modules/product-category'
import PromoRoutes from './modules/promo'
import ReviewRoutes from './modules/review'
import RoleRoutes from './modules/role'
import ShopOrderRoutes from './modules/shop-order'
import ShopOrderPaymentRoutes from './modules/shop-order-payments'
import StoreLocationRoutes from './modules/store-location'
import StoreSettingsRoutes from './modules/store-settings'
import UserAdminRoutes from './modules/useradmin'
import VoucherRoutes from './modules/voucher'

const routes: RouteRecordRaw[] = [
  layoutApp('/home', [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: { title: 'Dashboard' },
    },
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/css',
      name: 'css',
      component: () => import('@/views/app/css/page-index.vue'),
      meta: { title: 'CSS' },
    },
  ]),

  AuthRoutes,
  ErrorRoutes,

  layoutApp('/pengguna', UserAdminRoutes),
  layoutApp('/produk', ProductRoutes),
  layoutApp('/voucher', VoucherRoutes),
  layoutApp('/promo', PromoRoutes),
  layoutApp('/pesanan', ShopOrderRoutes),
  layoutApp('/konfirmasi-pembayaran', ShopOrderPaymentRoutes),
  layoutApp('/customer', CustomerRoutes),
  layoutApp('/ulasan', ReviewRoutes),
  layoutApp('/kategori-produk', ProductCategoryRoutes),
  layoutApp('/hak-akses', RoleRoutes),
  layoutApp('/banner', BannerRoutes),
  layoutApp('/banner-login', LoginBannerRoutes),
  layoutApp('/metode-pembayaran', PaymentMethodRoutes),
  layoutApp('/kurir', CourierRoutes),
  layoutApp('/lokasi-toko', StoreLocationRoutes),
  layoutApp('/pengaturan', StoreSettingsRoutes),
  layoutApp('/ubah-password', PasswordRoutes),
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: () => import('@/views/app/the-layout.vue'),
  }
}

export default routes
